module.exports = __webpack_public_path__ + "static/img/icon_hour_service.73c9f6d4.svg";